// frontend/src/components/CustomerBookingDemo.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import CustomerBookingForm from './CustomerBookingForm';

const CustomerBookingDemo = () => {
  const [showForm, setShowForm] = useState(false);
  const [submittedBookings, setSubmittedBookings] = useState([]);

  const handleBookingSubmit = async (bookingData) => {
    // Simulate API call - in real implementation, this would call your backend
    console.log('Booking submitted:', bookingData);
    
    // Add to submitted bookings list for demo purposes
    setSubmittedBookings(prev => [...prev, {
      ...bookingData,
      id: Date.now(),
      submittedAt: new Date().toLocaleString()
    }]);
    
    // In real implementation, you would make an API call here
    // await axios.post('/api/bookings', bookingData);
  };

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h4 className="mb-0">🚕 Customer Booking Form Demo</h4>
              <small className="text-muted">Web-link customer input form with exact same UI as "My Diary" Add Job</small>
            </Card.Header>
            <Card.Body>
              <Alert variant="info">
                <h5>📋 Form Features</h5>
                <ul className="mb-0">
                  <li><strong>📅 Date & Time:</strong> Interactive date/time picker with month, date, year, hour, minute, and AM/PM selection</li>
                  <li><strong>⏰ Wait & Return:</strong> Optional wait and return functionality with return time calculation</li>
                  <li><strong>👤 Customer Information:</strong> Name, email, and phone number fields</li>
                  <li><strong>🚗 Journey Details:</strong> From/to locations, passengers, fare amount, and special requirements (dog/pet, disabled access, return trip)</li>
                  <li><strong>📝 Notes:</strong> Additional notes field with character limit</li>
                  <li><strong>✅ Validation:</strong> Form validation with error messages</li>
                </ul>
              </Alert>
              
              <div className="text-center mb-4">
                <Button 
                  variant="success" 
                  size="lg"
                  onClick={() => setShowForm(true)}
                >
                  🚕 Book Your Taxi
                </Button>
              </div>

              {submittedBookings.length > 0 && (
                <div className="mt-4">
                  <h5>📋 Submitted Bookings ({submittedBookings.length})</h5>
                  <div className="row">
                    {submittedBookings.map((booking) => (
                      <div key={booking.id} className="col-md-6 mb-3">
                        <Card className="border-success">
                          <Card.Header className="bg-success text-white py-2">
                            <small>Submitted: {booking.submittedAt}</small>
                          </Card.Header>
                          <Card.Body className="py-2">
                            <div className="small">
                              <div><strong>Customer:</strong> {booking.customerName}</div>
                              <div><strong>Phone:</strong> {booking.customerPhone}</div>
                              <div><strong>Email:</strong> {booking.customerEmail}</div>
                              <div><strong>Route:</strong> {booking.from} → {booking.to}</div>
                              <div><strong>Date/Time:</strong> {new Date(booking.dateTime).toLocaleString()}</div>
                              <div><strong>Passengers:</strong> {booking.passengers}</div>
                              {booking.fareAmount && <div><strong>Fare:</strong> {booking.fareAmount}</div>}
                              {booking.dog && <div><strong>🐕 Dog/Pet:</strong> Yes</div>}
                              {booking.disabled && <div><strong>♿ Disabled Access:</strong> Yes</div>}
                              {booking.returnTrip && <div><strong>🔄 Return Trip:</strong> Yes</div>}
                              {booking.waitAndReturn && (
                                <div><strong>⏰ Wait & Return:</strong> {booking.waitHours} hours</div>
                              )}
                              {booking.notes && <div><strong>Notes:</strong> {booking.notes}</div>}
                            </div>
                          </Card.Body>
                        </Card>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <CustomerBookingForm 
        show={showForm}
        onHide={() => setShowForm(false)}
        onSubmit={handleBookingSubmit}
      />
    </Container>
  );
};

export default CustomerBookingDemo;
